/**
 * @param email {string}
 * @returns {void}
 */
module.exports = function updateForm1262ReturningUserEmail(email) {
    document.querySelectorAll('[data-component="form-1262-returning-user-email"]').forEach(emailPlaceholder => {
        emailPlaceholder.innerText = email;
    });
};